import React from "react";

export default function LoadingBox(props) {
  if (props?.justItem) {
    return (
      <div className="row bg-white mx-lg-1 shadow-sm rounded my-3">
        <div className="col-12 bg-white text-center">
          <div className="spinner-border text-secondary" role="status">
            <span className="sr-only"></span>
          </div>
          <br />
          cargando...
        </div>
      </div>
    );
  } else {
    return (
      <div className="row bg-white mx-lg-1 p-2 shadow-sm rounded my-3">
        <div className="col-12 p-3 p-lg-4 bg-white text-center">
          <div className="spinner-border text-secondary" role="status">
            <span className="sr-only"></span>
          </div>
          <br />
          cargando...
        </div>
      </div>
    );
  }
}
